module.exports = __webpack_public_path__ + "static/media/arrow-green.51f1ea1e.svg";